export default __webpack_public_path__ + "static/media/mariog5.8b56acc9.jpg";